import { Box, Grid, Menu, MenuItem, Stack } from '@mui/material';
import { useAvisoObra } from './hooks/useAvisoObra';
import SectionHeader from '../../components/SectionHeader';
import SearchToolbar from '../../components/SearchToolbar/SearchToolbar';
import { useTranslation } from 'react-i18next';
import NoTableDataImageSIMP from '../../assets/image/empty-state-establecimientos-simp.png';
import NoTableDataImageBO from '../../assets/image/empty-state-establecimientos-backoffice.png';
import { useRoles } from '../../hooks/useRoles';
import { useNavigate } from 'react-router-dom';
import AvisoObraFilters from './components/AvisoObraFilters';
import AvisoObraGrid from './components/AvisoObraGrid';
import DrawerAvisoObra from './components/AvisoObraDrawer';
import { useState } from 'react';
import { ActionType } from './consts/avisoObra.types';
import { EstadoAvisoObraEnum } from './consts/avisoObraStatesTypes';
import useGlobalFilters from '../../hooks/useGlobalFilters';
import { removeEmptyFields } from '../../utils/common';
import BackdropComponent from '../../components/Backdrop/BackdropComponent';

const AvisoObraIndex = () => {
    const { isAdminBO, isSupervisorSIMP, isOperatorSIMP, isViewerBO } = useRoles();
    const { t } = useTranslation('avisoObra');
    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerAction, setDrawerAction] = useState<ActionType | null>(null);
    const [selectedObra, setSelectedObra] = useState<any>(null);
    const [isShowMoreFiltersOpen, setIsShowMoreFiltersOpen] = useState<boolean>(false);

    const {
        filters,
        setFilters,
        extraFilters,
        handleSubmitSearch,
        handleChangeExtraFilters,
        debounceSearch,
        setExtraFilters,
        clearFilters,
        handleDirectFilter
    } = useGlobalFilters();

    const {
        avisos,
        isFetching: isFetchingList,

        anchorEl,
        selectedItem,
        handleOpenMenu,
        handleCloseMenu,
        handleVer,
        handleEditar,
        handleDescargar,
        handleSuspenderActionClick,
        handleExtenderActionClick,
        handleReiniciarActionClick,
        handleDeregisterActionClick,
        contratoOrganismoCentral,
        handleChangeEstado,
        handleCancelarAvisoObra,
        handleUploadProgramaActionClick,
        handleRevisionAvisoObra,
        handleRecepcionProgramaActionClick,
        handleAprobacionProgramaActionClick,
        handleConfirmDeregisterActionClick,
        isDownloadingPdf,
        handleGenerarNoObraPdf,
        fetchAvisosObra
    } = useAvisoObra(filters);

    const handleSearchFilters = () => {
        const rawFilters = {
            idOrganismoCentral: extraFilters?.idOrganismoCentral?.id,
            nroObra: extraFilters?.nroObra,
            idTipoObra: extraFilters?.idTipoObra?.id ? [extraFilters.idTipoObra.id] : undefined,
            localidad: extraFilters?.localidad?.id,
            idProvincia: extraFilters?.idProvincia?.id,
            estado: extraFilters?.estado?.id,
            fechaDesde: extraFilters?.fechaInicio
                ? new Date(extraFilters.fechaInicio).toISOString().split('T')[0]
                : undefined,
            fechaHasta: extraFilters?.fechaFin
                ? new Date(extraFilters.fechaFin).toISOString().split('T')[0]
                : undefined
        };

        const parsedFilters = removeEmptyFields(rawFilters);
        handleDirectFilter(parsedFilters);
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <SectionHeader>
                    <SectionHeader.Title>{t('header.title')}</SectionHeader.Title>
                    {isSupervisorSIMP && (
                        <SectionHeader.IconHeader
                            text={t('header.add')}
                            onClick={() => navigate('alta')}
                            showIcon={false}
                            disabled={!contratoOrganismoCentral}
                        />
                    )}
                </SectionHeader>
            </Grid>
            <Grid item xs={12}>
                <SearchToolbar
                    onChange={debounceSearch}
                    inputSearchName="nroObra"
                    label={t('filters.nroObra')}
                    onClick={handleSearchFilters}
                    clearFilters={clearFilters}
                    showSearchInput={false}
                    showMoreFiltersButton={true}
                    isShowMoreFiltersOpen={isShowMoreFiltersOpen}
                    handleShowMoreFiltersPress={() =>
                        setIsShowMoreFiltersOpen((prevState) => !prevState)
                    }
                >
                    <AvisoObraFilters
                        extraFilters={extraFilters}
                        handleChangeExtraFilters={handleChangeExtraFilters}
                        isShowMoreFiltersOpen={isShowMoreFiltersOpen}
                    />
                </SearchToolbar>
            </Grid>
            <Grid item xs={12}>
                <AvisoObraGrid
                    avisos={avisos}
                    filters={filters}
                    setFilters={setFilters}
                    isFetching={isFetchingList}
                    onSelectRow={handleOpenMenu}
                />
                <DrawerAvisoObra
                    open={drawerOpen}
                    setOpen={setDrawerOpen}
                    actionType={drawerAction}
                    selectedObra={selectedObra}
                    onSuccess={() => fetchAvisosObra(filters)}
                />

                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMenu}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                    disableAutoFocus
                >
                    {selectedItem &&
                        (() => {
                            const estado = selectedItem.idEstadosAvisoObra;

                            if (isSupervisorSIMP || isOperatorSIMP) {
                                switch (estado) {
                                    case EstadoAvisoObraEnum.BORRADOR:
                                        return (
                                            <>
                                                <MenuItem onClick={handleEditar}>
                                                    {t('actions.edit')}
                                                </MenuItem>
                                            </>
                                        );

                                    case EstadoAvisoObraEnum.RECIBIDO:
                                        return (
                                            <>
                                                <MenuItem onClick={handleVer}>
                                                    {t('actions.ver')}
                                                </MenuItem>
                                                <MenuItem onClick={handleDescargar}>
                                                    {t('actions.descargar')}
                                                </MenuItem>

                                                <MenuItem
                                                    onClick={() =>
                                                        handleUploadProgramaActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.uploadPrograma')}
                                                </MenuItem>
                                            </>
                                        );
                                    case EstadoAvisoObraEnum.PRESENTADO:
                                        return (
                                            <>
                                                <MenuItem onClick={handleVer}>
                                                    {t('actions.ver')}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() =>
                                                        handleExtenderActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.extender')}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() =>
                                                        handleSuspenderActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.suspender')}
                                                </MenuItem>
                                            </>
                                        );

                                    case EstadoAvisoObraEnum.EN_EXTENSION:
                                    case EstadoAvisoObraEnum.SUSPENDIDO:
                                        return (
                                            <>
                                                <MenuItem onClick={handleVer}>
                                                    {t('actions.ver')}
                                                </MenuItem>
                                                <MenuItem onClick={handleDescargar}>
                                                    {t('actions.descargar')}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() =>
                                                        handleUploadProgramaActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.uploadPrograma')}
                                                </MenuItem>
                                                {estado === EstadoAvisoObraEnum.SUSPENDIDO && (
                                                    <MenuItem
                                                        onClick={() =>
                                                            handleReiniciarActionClick(
                                                                setDrawerOpen,
                                                                setDrawerAction,
                                                                setSelectedObra
                                                            )
                                                        }
                                                    >
                                                        {t('actions.reiniciar')}
                                                    </MenuItem>
                                                )}
                                            </>
                                        );
                                    case EstadoAvisoObraEnum.EN_REVISION:
                                        return (
                                            <>
                                                <MenuItem onClick={handleVer}>
                                                    {t('actions.ver')}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() =>
                                                        handleUploadProgramaActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.uploadPrograma')}
                                                </MenuItem>
                                                <MenuItem onClick={handleDescargar}>
                                                    {t('actions.descargar')}
                                                </MenuItem>
                                            </>
                                        );
                                    case EstadoAvisoObraEnum.CANCELADO:
                                        return (
                                            <MenuItem onClick={handleVer}>
                                                {t('actions.ver')}
                                            </MenuItem>
                                        );

                                    case EstadoAvisoObraEnum.A_REVISAR:
                                        return (
                                            <>
                                                <MenuItem onClick={handleVer}>
                                                    {t('actions.ver')}
                                                </MenuItem>
                                                <MenuItem onClick={handleDescargar}>
                                                    {t('actions.descargar')}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() =>
                                                        handleUploadProgramaActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.uploadPrograma')}
                                                </MenuItem>
                                            </>
                                        );

                                    default:
                                        return (
                                            <>
                                                <MenuItem onClick={handleVer}>
                                                    {t('actions.ver')}
                                                </MenuItem>
                                                <MenuItem onClick={handleEditar}>
                                                    {t('actions.edit')}
                                                </MenuItem>
                                                <MenuItem onClick={handleDescargar}>
                                                    {t('actions.descargar')}
                                                </MenuItem>
                                                {estado === EstadoAvisoObraEnum.PRESENTADO && (
                                                    <>
                                                        <MenuItem
                                                            onClick={() =>
                                                                handleExtenderActionClick(
                                                                    setDrawerOpen,
                                                                    setDrawerAction,
                                                                    setSelectedObra
                                                                )
                                                            }
                                                        >
                                                            {t('actions.extender')}
                                                        </MenuItem>
                                                        <MenuItem
                                                            onClick={() =>
                                                                handleSuspenderActionClick(
                                                                    setDrawerOpen,
                                                                    setDrawerAction,
                                                                    setSelectedObra
                                                                )
                                                            }
                                                        >
                                                            {t('actions.suspender')}
                                                        </MenuItem>
                                                    </>
                                                )}
                                                <MenuItem
                                                    onClick={() =>
                                                        handleUploadProgramaActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.uploadPrograma')}
                                                </MenuItem>
                                            </>
                                        );
                                }
                            }

                            if (isViewerBO && selectedItem) {
                                return (
                                    <>
                                        <MenuItem onClick={handleVer}>{t('actions.ver')}</MenuItem>
                                        <MenuItem onClick={handleDescargar}>
                                            {t('actions.descargar')}
                                        </MenuItem>
                                    </>
                                );
                            }

                            if (isAdminBO && selectedItem) {
                                const estado = selectedItem.idEstadosAvisoObra;

                                return (
                                    <>
                                        <MenuItem onClick={handleVer}>{t('actions.ver')}</MenuItem>
                                        {estado === EstadoAvisoObraEnum.RECIBIDO && (
                                            <>
                                                <MenuItem
                                                    onClick={() =>
                                                        handleRevisionAvisoObra(selectedItem.id)
                                                    }
                                                >
                                                    {t('actions.enRevision')}
                                                </MenuItem>
                                                <MenuItem onClick={handleDescargar}>
                                                    {t('actions.descargar')}
                                                </MenuItem>

                                                <MenuItem
                                                    onClick={() =>
                                                        handleRecepcionProgramaActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.receivePrograma')}
                                                </MenuItem>

                                                <MenuItem
                                                    onClick={() =>
                                                        handleConfirmDeregisterActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.cancel')}
                                                </MenuItem>
                                            </>
                                        )}
                                        {estado === EstadoAvisoObraEnum.EN_REVISION && (
                                            <>
                                                <MenuItem onClick={handleDescargar}>
                                                    {t('actions.descargar')}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() =>
                                                        handleChangeEstado(
                                                            selectedItem.id,
                                                            EstadoAvisoObraEnum.PRESENTADO
                                                        )
                                                    }
                                                >
                                                    {t('actions.presentado')}
                                                </MenuItem>

                                                <MenuItem
                                                    onClick={() =>
                                                        handleChangeEstado(
                                                            selectedItem.id,
                                                            EstadoAvisoObraEnum.A_REVISAR
                                                        )
                                                    }
                                                >
                                                    {t('actions.revisar')}
                                                </MenuItem>

                                                {selectedItem.idTipoResolucion !== 2 && (
                                                    <MenuItem
                                                        onClick={() =>
                                                            handleGenerarNoObraPdf(selectedItem.id)
                                                        }
                                                    >
                                                        {t('actions.generarNoObra')}
                                                    </MenuItem>
                                                )}

                                                {estado === EstadoAvisoObraEnum.EN_REVISION &&
                                                    isAdminBO &&
                                                    selectedItem.idTipoResolucion !== 2 && (
                                                        <MenuItem
                                                            onClick={() =>
                                                                handleAprobacionProgramaActionClick(
                                                                    setDrawerOpen,
                                                                    setDrawerAction,
                                                                    setSelectedObra
                                                                )
                                                            }
                                                        >
                                                            {t('actions.approvePrograma')}
                                                        </MenuItem>
                                                    )}
                                                <MenuItem
                                                    onClick={() =>
                                                        handleConfirmDeregisterActionClick(
                                                            setDrawerOpen,
                                                            setDrawerAction,
                                                            setSelectedObra
                                                        )
                                                    }
                                                >
                                                    {t('actions.cancel')}
                                                </MenuItem>
                                            </>
                                        )}
                                        {estado === EstadoAvisoObraEnum.PRESENTADO && (
                                            <>
                                                <MenuItem onClick={handleDescargar}>
                                                    {t('actions.descargar')}
                                                </MenuItem>
                                            </>
                                        )}
                                    </>
                                );
                            }
                            return null;
                        })()}
                </Menu>
            </Grid>
            <BackdropComponent loading={isDownloadingPdf} />
        </Grid>
    );
};

export default AvisoObraIndex;
